export const PAYABLE_APPROVALS_SEARCH_PLACEHOLDER = "Search by Vendor Invoice #, Vendor Name, Amount..."
